import { render, staticRenderFns } from "./ThematicAreaDetails.vue?vue&type=template&id=4f716797&scoped=true"
import script from "./ThematicAreaDetails.vue?vue&type=script&lang=js"
export * from "./ThematicAreaDetails.vue?vue&type=script&lang=js"
import style0 from "./ThematicAreaDetails.vue?vue&type=style&index=0&id=4f716797&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f716797",
  null
  
)

export default component.exports